import { request } from "@/Api";
import { CustomRow } from "@/table/CustomTable";
import {
    Autocomplete,
    Checkbox,
    Chip,
    Collapse,
    Link,
    TableCell,
    TableRow,
    TextField,
    Tooltip,
} from "@mui/material";
import AccountingBillActions from "./AccountingBillActions";
import { memo, useEffect, useState } from "react";
import { formattedCurrency } from "@/utils";
import { useSelector } from "react-redux";
import {
    checkBill,
    selectBillIsChecked,
    unCheckBill,
} from "./accountingBillsSlice";
import {
    ACCOUNTING_BILL_STATUS_ALLOCATED,
    ACCOUNTING_BILL_STATUS_PAID,
} from "@/actuals/constants";
import { useDispatch } from "react-redux";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { VENDOR_STATUS_ACTIVE } from "@/vendor/constants";
import AccountingBillLines from "./AccountingBillLines";

export const AccountingBillRow = ({
    item,
    deleteItem,
    categories,
    taxCodes,
}) => {
    const handleRefute = (bill) => {
        deleteItem(bill.id);
    };
    return (
        <AccountingBill
            billData={item}
            onRefuteSuccess={handleRefute}
            categories={categories[item.legal_entity_id] || []}
            taxCodes={taxCodes[item.legal_entity_id] || []}
        />
    );
};

const AccountingBill = ({ billData, hidden, onRefuteSuccess }) => {
    const dispatch = useDispatch();
    const [bill, setBill] = useState(billData);
    const [expanded, setExpanded] = useState(false);
    const selected = useSelector((state) =>
        selectBillIsChecked(state, bill.id),
    );
    const checkboxAvailable =
        bill.status && bill.status != ACCOUNTING_BILL_STATUS_PAID;
    const vendorInfoComplete = bill.vendor_status == VENDOR_STATUS_ACTIVE;
    const canSync =
        bill.status == ACCOUNTING_BILL_STATUS_ALLOCATED && vendorInfoComplete;
    const mainPaid = bill.status == ACCOUNTING_BILL_STATUS_PAID;
    const handleCheck = (event, isChecked) => {
        if (isChecked) {
            dispatch(checkBill(bill));
        } else {
            dispatch(unCheckBill(bill));
        }
    };
    const handleExpand = () => {
        setExpanded(!expanded);
    };
    return (
        <>
            <CustomRow style={{ display: hidden ? "none" : "table-row" }}>
                <TableCell align="left" width={50}>
                    {checkboxAvailable && (
                        <Tooltip
                            title={
                                canSync
                                    ? ""
                                    : "Can't act on this bill because vendor information is incomplete"
                            }
                        >
                            <span>
                                <Checkbox
                                    disabled={!canSync}
                                    checked={selected}
                                    onChange={handleCheck}
                                />
                            </span>
                        </Tooltip>
                    )}
                    {mainPaid && <CheckCircleOutlineRoundedIcon />}
                </TableCell>
                <TableCell align="left" sx={{ minWidth: 200 }}>
                    {bill.vendor_id ? (
                        <Link href={`/vendors/${bill.vendor_id}`}>
                            {bill.vendor_display_name}
                        </Link>
                    ) : (
                        <span>{bill.vendor_display_name || "-"}</span>
                    )}
                </TableCell>
                <TableCell component="th" scope="row">
                    {bill.accounting_bill_number}
                </TableCell>
                <TableCell align="left">
                    <Chip
                        variant="outlined"
                        label={bill.status || "unmatched"}
                    />
                </TableCell>
                <TableCell align="right">
                    {formattedCurrency(bill.actual, bill.currency, false, 2)}
                </TableCell>
                <TableCell align="right">
                    {formattedCurrency(
                        bill.actual_project,
                        bill.project_currency,
                        false,
                        2,
                    )}
                </TableCell>
                <TableCell align="left">
                    <div style={{ width: 100 }}>{bill.legal_entity_name}</div>
                </TableCell>
                <TableCell align="right">
                    <AccountingBillActions
                        bill={bill}
                        onExpand={handleExpand}
                        onRefuteSuccess={onRefuteSuccess}
                    />
                </TableCell>
            </CustomRow>
            <TableRow>
                <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={12}
                >
                    <Collapse in={expanded} unmountOnExit>
                        <div style={{ padding: 10 }}>
                            <div>Lines</div>
                            <AccountingBillLines accountingBill={bill} />
                        </div>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default AccountingBill;
